import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { DueDiligenceDocumentationRequirement, DueDiligenceDocumentationUpload } from '@gcv/shared';

interface DocumentationWithType extends DueDiligenceDocumentationUpload {
  type: string;
  id: string;
}

@Component({
  selector: 'gcv-review-account-documents-table',
  templateUrl: './review-account-documents-table.component.html',
  styleUrls: ['./review-account-documents-table.component.scss'],
})
export class ReviewAccountDocumentsTableComponent implements OnInit {
  @Input() documents: DueDiligenceDocumentationRequirement;
  transformedDocs: DocumentationWithType[];
  filteredDocuments: DocumentationWithType[];
  sortedDocuments: DocumentationWithType[];
  sort: { active: string; direction: 'asc' | 'desc' | '' } = { active: '', direction: '' };
  filterToggled = false;
  displayedColumns: string[] = ['requirement', 'type', 'reviewed', 'reviewed_by'];
  filter = { financial: false, legal: false, operational: false };
  @Output() openDocumentEmitter = new EventEmitter<DocumentationWithType>();

  constructor() {}

  ngOnInit() {
    this.transformedDocs = this.makeDocumentsArray();
    this.filteredDocuments = this.transformedDocs.slice();
    this.sortedDocuments = this.filteredDocuments.slice();
  }

  makeDocumentsArray() {
    const docArray = [];
    for (const category in this.documents) {
      if (this.documents[category]) {
        for (const id in this.documents[category]) {
          if (this.documents[category][id]) {
            const doc = this.documents[category][id] as DocumentationWithType;
            doc.type = category;
            doc.id = id;
            docArray.push(doc);
          }
        }
      }
    }
    return docArray;
  }

  handleFilterToggle(event) {
    event.stopPropagation();
    this.filterToggled = !this.filterToggled;
  }

  handleRowClick(row) {
    this.openDocumentEmitter.emit(row);
  }

  stopPropagation(event) {
    event.stopPropagation();
  }

  filterDocuments() {
    if (this.filter.financial || this.filter.legal || this.filter.operational) {
      this.filteredDocuments = this.transformedDocs.filter(doc => {
        if (this.filter.financial && doc.type.toLowerCase() === 'financial') {
          return true;
        }
        if (this.filter.legal && doc.type.toLowerCase() === 'legal') {
          return true;
        }
        if (this.filter.operational && doc.type.toLowerCase() === 'operational') {
          return true;
        }
        return false;
      });
    } else {
      this.filteredDocuments = this.transformedDocs.slice();
    }
    this.sortDocuments(this.sort);
  }

  sortDocuments(sort) {
    if (sort) {
      this.sort = sort;
    }
    const data = this.filteredDocuments.slice();
    if (!this.sort.active || this.sort.direction === '') {
      this.sortedDocuments = data;
      return;
    }
    this.sortedDocuments = data.sort((a, b) => {
      const isAsc = this.sort.direction === 'asc';
      switch (this.sort.active) {
        case 'requirement':
          return compare(a.name, b.name, isAsc);
        case 'type':
          return compare(a.type, b.type, isAsc);
        case 'reviewed':
          return compare(a.status, b.status, isAsc);
        case 'reviewed_by':
          return compare(a.reviewed_by, b.reviewed_by, isAsc);
        default:
          return 0;
      }
    });
  }
}

function compare(a: number | string, b: number | string, isAsc: boolean) {
  return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
}
